/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const GET_APPLICATION = gql`
  query GetApplication($applicationNo: String!) {
    getApplication(applicationNo: $applicationNo) {
      documents {
        name
        type
        src
        fileType
        expiry
      }
      comment
      status
      type
      applicationNo
      applicantInfo {
        firstName
        middleName
        lastName
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          parish
          zipcode
          country
        }
        placeOfBirth
        countryOfBirth
        primaryContactNo
        email
        gender
        dateOfBirth
        nationality
        maritalStatus
        qualification {
          institute
          from
          to
          dateReceived
          degree
          degreeIfOther
          description
          
        }
        occupation
        passportNumber
        passportExpiry
        natureOfBusiness
        intendedAddress {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          parish
          zipcode
          country
        }
      }
    }
  }
`;
